module.exports = __webpack_public_path__ + "static/media/a3-min.eafe56de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/a3-min.svg
// module id = 689
// module chunks = 0